/*
 * Signed-in destinations shown in the account dropdown and the mobile
 * drawer. One list so the two menus cannot drift apart.
 */
import { CreditCard, LayoutDashboard, Heart, Package, Settings, ShieldCheck } from 'lucide-vue-next';
import type { Component } from 'vue';

export interface AccountLink {
  to: string;
  /** `header.menu.*` i18n key suffix. */
  label: 'dashboard' | 'orders' | 'wishlist' | 'billing' | 'settings' | 'admin';
  icon: Component;
}

export const ACCOUNT_LINKS: AccountLink[] = [
  { to: '/account', label: 'dashboard', icon: LayoutDashboard },
  { to: '/orders', label: 'orders', icon: Package },
  { to: '/favorites', label: 'wishlist', icon: Heart },
  { to: '/account/billing', label: 'billing', icon: CreditCard },
  { to: '/account/settings', label: 'settings', icon: Settings },
];

export const ADMIN_LINK: AccountLink = { to: '/admin', label: 'admin', icon: ShieldCheck };
